






























































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
import { voucherTypes } from '@/tenant/common/All';

@Component
export default class CategoryView extends Vue {
  public items: Common.ProjectItem[] = new Array(0);
  public params: Common.ProjectItemQuery = new Common.ProjectItemQuery();
  public importQuery = new Common.ImportQuery('案件', 'ProjectItem');
  public exportQuery = new Common.ExportQuery('案件', this.params);
  @Prop() public projectItemNo:string;
  @Prop({default:null}) public popup: Components.PopupEditor;  

  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'projectItemNo', text: '案件番号' },
    { value: 'name', text: '案件名称' },
    { value: 'counterpart', text: '得意先' },    
    { value: 'startDate', text: '開始日' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },    
  ];
  public voucherTypes = Common.voucherTypes;
  
  public created() {
    // 検索条件を設定する
    if(this.projectItemNo) {
      this.params.projectItemNo = this.projectItemNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
      this.params.state = this.$api.onlyOpen ? Common.ProjectItemStatus.Active : null;
    }
  }

  public async onCreate(obj: Common.ProjectItem) {
    const workflows = this.$api.formatter.getOptions('workflow_projectItem');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public onPopupClosing(voucherType : Common.voucherTypes){
    if (voucherType != Common.voucherTypes.SalesOrder) (this.$refs.salesOrder as Components.GrdVoucherItem).onVoucherNoChanged();
    if (voucherType != Common.voucherTypes.SalesDelivery) (this.$refs.salesDelivery as Components.GrdVoucherItem).onVoucherNoChanged();
    if (voucherType != Common.voucherTypes.PurchaseOrder) (this.$refs.purchaseOrder as Components.GrdVoucherItem).onVoucherNoChanged();
    if (voucherType != Common.voucherTypes.PurchaseDelivery) (this.$refs.purchaseDelivery as Components.GrdVoucherItem).onVoucherNoChanged();
    (this.$refs.stockBalance as Components.GrdVoucherItem).onVoucherNoChanged();            
  }

  // 粗利計算
  public grossProfit: number = 0;
  public salesOrderAmount: number = 0;
  public purchaseOrderAmount: number = 0;  
  public afterVoucherNoChanged(voucherType : Common.voucherTypes){
    if (voucherType == Common.voucherTypes.SalesOrder) {
      this.salesOrderAmount = 0;
      var items =  (this.$refs.salesOrder as Components.GrdVoucherItem).items as Common.Order[];
      items.forEach(obj => this.salesOrderAmount += obj.amountFC);
    } else if (voucherType == Common.voucherTypes.PurchaseOrder) {
      this.purchaseOrderAmount = 0;
      var items =  (this.$refs.purchaseOrder as Components.GrdVoucherItem).items as Common.Order[];
      items.forEach(obj => this.purchaseOrderAmount += obj.amountFC);
    }
    this.grossProfit = this.salesOrderAmount - this.purchaseOrderAmount;
  }  
}
